import { SettingsContext } from "@/utilities/settings-context";
import axios from "axios";

export const getJobDomains = async (postingId: number): Promise<string[]> => {
    try {
        const response = await axios.get<Array<string>>(`${SettingsContext.getApiUrl('getTargetScopeDomains')}/${postingId}`);

        return response.data;
    }
    catch {
        return [];
    }
}
    